import React, { useEffect, useState } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import { IconArrowBack } from "@tabler/icons";
import RadialGeofenceMap from "src/components/mapFencing/RadialGeofenceMap";
import LocationService from "src/service/location";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Add Location",
  },
];

const validationSchema = yup.object({
  radius: yup
    .string("Enter Radius in km")
    .matches(/^[0-9.]{1,6}$/, "Invalid Radius")
    .required("Radius is Required"),
  location_name: yup.string("Enter location").required("Location is Required"),
  //   lat: yup.string("Enter Latitude").required("Latitude is Required"),
  //   lng: yup.string("Enter Longitude").required("Longitude is Required"),
});

const AddPOILocation = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [starting_latitude, setStarting_latitude] = useState("");
  const [starting_longitude, setStarting_longitude] = useState("");

  const [startMarker, setStartMarker] = useState({
    position: { lat: 23.876536, lng: 85.876453 },
    address: "",
  });

  // eslint-disable-next-line no-unused-vars
  const [endMarker, setEndMarker] = useState({
    position: { lat: 23.876536, lng: 85.876453 },
    address: "",
  });

  // Function to reverse geocode latitude and longitude to get the place name

  const calculateEndingCoordinates = (startLat, startLng, distance) => {
    const endingLat = startLat + distance / 111.32;
    const endingLng = startLng;
    return { lat: endingLat, lng: endingLng };
  };

  const initialValues = {
    location_name: "",
    lat: "",
    lng: "",
    radius: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        const payloadval = {
          location_name: values.location_name,
          lat: starting_latitude,
          lng: starting_longitude,
          radius: values.radius,
          c_by: sessionData.data.id,
        };

        try {
          const res = await LocationService.add_location(payloadval);
          swal("Success", res.message, "success");
          setTimeout(() => {
            navigate("/poilocation");
          }, 1000);
        } catch (error) {
          swal("Error", error, "error");
        }
      },
    });

  const handleValuesChange = () => {
    if (starting_latitude && starting_longitude && values.radius) {
      const endingCoordinates = calculateEndingCoordinates(
        parseFloat(starting_latitude),
        parseFloat(starting_longitude),
        parseFloat(values.radius)
      );
      setEndMarker({
        position: endingCoordinates,
        address: `Geofencing Area (Radius: ${values.radius} km)`,
      });
    }
  };

  useEffect(() => {
    handleValuesChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [starting_latitude, starting_longitude, values.radius]);

  useEffect(() => {
    if (starting_latitude && starting_longitude) {
      setStartMarker({
        position: {
          lat: parseFloat(starting_latitude),
          lng: parseFloat(starting_longitude),
        },
      });
    }
  }, [starting_latitude, starting_longitude]);

  return (
    <>
      <Breadcrumb title="Add Location" items={BCrumb} />
      <ParentCard title="" style={{ minHeight: "600px !important" }}>
        <Grid container alignItems="center">
          <Grid item xs={4}>
            <Typography
              variant="h2"
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
                marginTop: "15px",
                marginBottom: "15px",
              }}
            >
              Add Location
            </Typography>
          </Grid>
          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginTop: "15px",
              marginBottom: "15px",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/poilocation")}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <CustomFormLabel htmlFor="location_name">
                    Location Name <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id="location_name"
                    name="location_name"
                    type="text"
                    value={values.location_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.location_name && Boolean(errors.location_name)
                    }
                    helperText={touched.location_name && errors.location_name}
                    placeholder="Enter location Name"
                    fullWidth
                  />
                </Grid>

                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <CustomFormLabel htmlFor="start_pt_latitude">
                    Latitude <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    type="text"
                    value={starting_latitude}
                    onChange={(e) => {
                      setStarting_latitude(e.target.value);
                      // handleChange();
                    }}
                    onBlur={handleBlur}
                    fullWidth
                  />
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <CustomFormLabel htmlFor="start_pt_longitude">
                    Longitude <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    type="text"
                    value={starting_longitude}
                    onChange={(e) => {
                      setStarting_longitude(e.target.value);
                      // handleChange();
                    }}
                    onBlur={handleBlur}
                    fullWidth
                  />
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <CustomFormLabel htmlFor="radius">
                    Radius (Km) <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id="radius"
                    name="radius"
                    type="text"
                    value={values.radius}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.radius && Boolean(errors.radius)}
                    helperText={touched.radius && errors.radius}
                    placeholder="Enter Radius in Km"
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <RadialGeofenceMap
                  center={startMarker.position}
                  radius={values.radius}
                  markerPosition={startMarker.position}
                />
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12}>
              <Button type="submit" color="success" variant="contained">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </>
  );
};

export default AddPOILocation;
